import emailIcon from '../assets/socialIcons/iconmonstr-email-1-240 black.png';
import githubIcon from '../assets/socialIcons/iconmonstr-github-1-240_black.png';
import linkedinIcon from '../assets/socialIcons/iconmonstr-linkedin-3-240_black.png';
import instagramIcon from '../assets/socialIcons/iconmonstr-instagram-11-240_black.png';

export const socials = [
  {
    "title": "Email",
    "link": "#contact",
    "image": emailIcon
  },
  {
    "title": "Github",
    "link": "https://github.com/seanmarjason/seanmarjason.com",
    "image": githubIcon
  },
  {
    "title": "LinkedIn",
    "link": "https://www.linkedin.com/in/seanmarjason/",
    "image": linkedinIcon
  },
  {
    "title": "Instagram",
    "link": "https://www.instagram.com/seanmarjason/",
    "image": instagramIcon
  },
];
